import {jwtDecode} from "jwt-decode";

export namespace JwtUtils {

    /**
     * 토큰의 만료여부 리턴
     * 실제 만료된 경우, 디코딩 중 에러가 발생한 경우 모두 true 리턴
     */
    export function isExpired(token: string): boolean {
        try {
            const decodedToken: any = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);

            // token has expired
            if (decodedToken.exp && decodedToken.exp < currentTime) {
                return true;
            }
        } catch (error) {
            console.error('Error decoding token: ', error);
            return true;
        }

        return false;
    }

    /**
     * localStorage로부터 accessToken을 가져온다
     * 없거나 만료된 경우 null을 반환한다
     */
    export function getTokenFromLocalStorage(key: string): string | null {
        const accessToken = localStorage.getItem(key);
        if (accessToken === null) {
            return null;
        }

        if (JwtUtils.isExpired(accessToken)) {
            return null;
        }

        return accessToken;
    }

}